// rel="noopener" kept as in the design (noreferrer would hide the referrer from stores/WhatsApp)
/* eslint-disable react/jsx-no-target-blank */
import { useHomeText } from '../text';

const Contact = () => {
  const t = useHomeText();
  return (
    <section id="contact" style={{ maxWidth: "1280px", margin: "0 auto", padding: "112px 24px", display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(min(460px, 100%), 1fr))", gap: "32px", alignItems: "stretch" }}>
      <div style={{ background: "#141C63", color: "#FFFFFF", borderRadius: "32px", padding: "clamp(28px, 4vw, 48px)", display: "flex", flexDirection: "column", gap: "24px", position: "relative", overflow: "hidden" }}>
        <img width="404" height="452" loading="lazy" decoding="async" src="/assets/img/boy-learning.webp" alt="" style={{ position: "absolute", bottom: "-20px", left: "-10px", width: "240px", height: "auto", opacity: "0.95" }} />
        <span style={{ fontWeight: "700", color: "#46D3BE" }}>
          {t.contact.contact}
        </span>
        <h2 style={{ margin: "0", fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontWeight: "800", fontSize: "clamp(32px, 3.6vw, 46px)", lineHeight: "1.2" }}>
          {t.contact.takeTheFirstStep}
        </h2>
        <div style={{ display: "flex", flexDirection: "column", gap: "16px", position: "relative", maxWidth: "360px" }}>
          <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
            <span style={{ fontSize: "14px", color: "#C9CEF5" }}>
              {t.contact.customerService}
            </span>
            <a href="tel:+21656078078" style={{ color: "#FFFFFF", fontWeight: "800", fontSize: "22px", textDecoration: "none" }} dir="ltr">
              +216 56 078 078
            </a>
          </div>
          <a href="https://wa.me/21656078078?text=%D9%85%D8%B1%D8%AD%D8%A8%D8%A7%20%D8%AE%D8%B7%D9%88%D8%A9%D8%8C%20%D8%A3%D8%B1%D9%8A%D8%AF%20%D9%85%D8%B9%D9%84%D9%88%D9%85%D8%A7%D8%AA%20%D8%B9%D9%86%20%D8%A7%D9%84%D8%AA%D8%B7%D8%A8%D9%8A%D9%82" target="_blank" rel="noopener" style={{ alignSelf: "flex-start", display: "inline-flex", alignItems: "center", gap: "10px", minHeight: "54px", padding: "0 22px", borderRadius: "18px", background: "#25D366", color: "#FFFFFF", fontWeight: "800", fontSize: "17px", textDecoration: "none", boxShadow: "0 5px 0 #128C4B" }}>
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M4 20l1.300-3.900A8 8 0 1 1 8 19z" />
              <path d="M9.200 8.600c.300 2.600 2.600 5 5.200 5.400l1-1.200-1.800-.900-.700.700c-.900-.400-1.700-1.200-2.100-2.100l.700-.700-.900-1.800z" fill="#FFFFFF" strokeWidth="1" />
            </svg>
            <span>
              {t.contact.messageUsOnWhatsapp}
            </span>
          </a>
          <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
            <span style={{ fontSize: "14px", color: "#C9CEF5" }}>
              {t.contact.email}
            </span>
            <a href="mailto:contact@khotoua.com" style={{ color: "#FFFFFF", fontWeight: "800", fontSize: "20px", textDecoration: "none" }} dir="ltr">
              contact@khotoua.com
            </a>
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
            <span style={{ fontSize: "14px", color: "#C9CEF5" }}>
              {t.contact.socialMedia}
            </span>
            <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
              <a href="https://www.instagram.com/khotoua_game/" target="_blank" rel="noopener" style={{ display: "inline-flex", alignItems: "center", gap: "8px", minHeight: "44px", padding: "0 14px", borderRadius: "12px", background: "rgba(255,255,255,0.1)", color: "#FFFFFF", textDecoration: "none", fontWeight: "600" }}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" strokeWidth="2" aria-hidden="true">
                  <rect x="3" y="3" width="18" height="18" rx="5" />
                  <circle cx="12" cy="12" r="4" />
                  <circle cx="17.5" cy="6.5" r="1" fill="#FFFFFF" />
                </svg>
                {t.contact.instagram}
              </a>
              <a href="https://www.facebook.com/khotoua.game" target="_blank" rel="noopener" style={{ display: "inline-flex", alignItems: "center", gap: "8px", minHeight: "44px", padding: "0 14px", borderRadius: "12px", background: "rgba(255,255,255,0.1)", color: "#FFFFFF", textDecoration: "none", fontWeight: "600" }}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <path d="M15 3h-2.500A3.500 3.500 0 0 0 9 6.500V10H6.500v3.500H9V21h3.500v-7.500H15l.500-3.500h-3V7a1 1 0 0 1 1-1H15z" />
                </svg>
                {t.contact.facebook}
              </a>
              <a href="https://www.tiktok.com/@khotoua_game" target="_blank" rel="noopener" style={{ display: "inline-flex", alignItems: "center", gap: "8px", minHeight: "44px", padding: "0 14px", borderRadius: "12px", background: "rgba(255,255,255,0.1)", color: "#FFFFFF", textDecoration: "none", fontWeight: "600" }}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <path d="M14 3v11.500a3.500 3.500 0 1 1-3.500-3.500" />
                  <path d="M14 3c.500 2.500 2.500 4.500 5 4.500" />
                </svg>
                {t.contact.tiktok}
              </a>
              <a href="https://www.linkedin.com/company/khotoua/" target="_blank" rel="noopener" style={{ display: "inline-flex", alignItems: "center", gap: "8px", minHeight: "44px", padding: "0 14px", borderRadius: "12px", background: "rgba(255,255,255,0.1)", color: "#FFFFFF", textDecoration: "none", fontWeight: "600" }}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <rect x="3" y="3" width="18" height="18" rx="3" />
                  <path d="M8 10v7M8 7v.01M12 17v-4a2 2 0 0 1 4 0v4M12 10v7" />
                </svg>
                {t.contact.linkedin}
              </a>
              <a href="https://www.youtube.com/@Khotoua" target="_blank" rel="noopener" style={{ display: "inline-flex", alignItems: "center", gap: "8px", minHeight: "44px", padding: "0 14px", borderRadius: "12px", background: "rgba(255,255,255,0.1)", color: "#FFFFFF", textDecoration: "none", fontWeight: "600" }}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" strokeWidth="2" strokeLinejoin="round" aria-hidden="true">
                  <rect x="2.500" y="5.500" width="19" height="13" rx="4" />
                  <path d="M10 9.500l5 2.500-5 2.500z" fill="#FFFFFF" />
                </svg>
                {t.contact.youtube}
              </a>
            </div>
          </div>
        </div>
      </div>
      <form id="kh-lead" action="https://formgrid.dev/api/f/s6e3dfao" method="post" noValidate aria-label={t.contact.requestADemoLabel} style={{ background: "#FFFFFF", border: "1px solid #E1E5F7", borderRadius: "32px", padding: "clamp(24px, 4vw, 44px)", display: "flex", flexDirection: "column", gap: "16px" }}>
        <h3 style={{ margin: "0", fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontSize: "30px" }}>
          {t.contact.requestADemo}
        </h3>
        <fieldset style={{ border: "0", margin: "0", padding: "0", display: "flex", gap: "10px", flexWrap: "wrap" }}>
          <legend style={{ fontWeight: "700", marginBottom: "10px" }}>
            {t.contact.iAmA}
          </legend>
          <label data-who-label="parent" style={{ display: "inline-flex", alignItems: "center", gap: "8px", minHeight: "44px", padding: "0 16px", borderRadius: "999px", border: "2px solid #141C63", fontWeight: "600", cursor: "pointer" }}>
            <input type="radio" name="who" value="parent" defaultChecked />
            {t.contact.parent}
          </label>
          <label data-who-label="school" style={{ display: "inline-flex", alignItems: "center", gap: "8px", minHeight: "44px", padding: "0 16px", borderRadius: "999px", border: "2px solid #E1E5F7", fontWeight: "600", cursor: "pointer" }}>
            <input type="radio" name="who" value="school" />
            <span>
              {t.contact.school}
            </span>
          </label>
          <label data-who-label="partner" style={{ display: "inline-flex", alignItems: "center", gap: "8px", minHeight: "44px", padding: "0 16px", borderRadius: "999px", border: "2px solid #E1E5F7", fontWeight: "600", cursor: "pointer" }}>
            <input type="radio" name="who" value="partner" />
            {t.contact.institutionPartner}
          </label>
        </fieldset>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(min(200px, 100%), 1fr))", gap: "14px" }}>
          <label style={{ display: "flex", flexDirection: "column", gap: "6px", fontSize: "14px", fontWeight: "600" }}>
            <span>
              {t.contact.fullName}
              <span className="kh-req" aria-hidden="true">
                {" *"}
              </span>
            </span>
            <input type="text" name="name" autoComplete="name" required minLength={3} style={{ minHeight: "50px", borderRadius: "14px", border: "1.5px solid #B8C0EA", padding: "0 14px" }} />
          </label>
          <label style={{ display: "flex", flexDirection: "column", gap: "6px", fontSize: "14px", fontWeight: "600" }}>
            <span>
              {t.contact.phone}
              <span className="kh-req" aria-hidden="true">
                {" *"}
              </span>
            </span>
            <input type="tel" name="phone" autoComplete="tel" inputMode="tel" required dir="ltr" placeholder="+216" style={t.contact.ltrInputStyle} />
          </label>
        </div>
        <label style={{ display: "flex", flexDirection: "column", gap: "6px", fontSize: "14px", fontWeight: "600" }}>
          <span>
            {t.contact.email}
            <span className="kh-req" aria-hidden="true">
              {" *"}
            </span>
          </span>
          <input type="email" name="email" autoComplete="email" required dir="ltr" style={t.contact.ltrInputStyle} />
        </label>
        <div data-who-panel="parent">
          <label style={{ display: "flex", flexDirection: "column", gap: "6px", fontSize: "14px", fontWeight: "600" }}>
            <span>
              {t.contact.childSSchoolYear}
              <span className="kh-req" aria-hidden="true">
                {" *"}
              </span>
            </span>
            <select name="level" required data-req-when="parent" style={{ minHeight: "50px", borderRadius: "14px", border: "1.5px solid #B8C0EA", padding: "0 12px", background: "#FFFFFF" }} defaultValue="">
              <option value="" disabled>
                {t.contact.chooseAYear}
              </option>
              <option>
                {t.contact.preSchool}
              </option>
              <option>
                {t.contact.primaryYear1}
              </option>
              <option>
                {t.contact.primaryYear2}
              </option>
              <option>
                {t.contact.primaryYear3}
              </option>
              <option>
                {t.contact.primaryYear4}
              </option>
              <option>
                {t.contact.primaryYear5}
              </option>
              <option>
                {t.contact.primaryYear6}
              </option>
            </select>
          </label>
        </div>
        <div data-who-panel="school" hidden>
          <label style={{ display: "flex", flexDirection: "column", gap: "6px", fontSize: "14px", fontWeight: "600" }}>
            <span>
              {t.contact.schoolName}
              <span className="kh-req" aria-hidden="true">
                {" *"}
              </span>
            </span>
            <input type="text" name="school" data-req-when="school" placeholder={t.contact.eGPrivateSchoolPlaceholder} style={{ minHeight: "50px", borderRadius: "14px", border: "1.5px solid #B8C0EA", padding: "0 14px" }} />
          </label>
        </div>
        <div data-who-panel="partner" hidden>
          <label style={{ display: "flex", flexDirection: "column", gap: "6px", fontSize: "14px", fontWeight: "600" }}>
            <span>
              {t.contact.institutionName}
              <span className="kh-req" aria-hidden="true">
                {" *"}
              </span>
            </span>
            <input type="text" name="organization" data-req-when="partner" style={{ minHeight: "50px", borderRadius: "14px", border: "1.5px solid #B8C0EA", padding: "0 14px" }} />
          </label>
        </div>
        <input type="text" name="website" tabIndex={-1} autoComplete="off" aria-hidden="true" style={{ position: "absolute", width: "1px", height: "1px", margin: "0", padding: "0", border: "0", overflow: "hidden", clipPath: "inset(50%)", opacity: "0", pointerEvents: "none" }} />
        <p id="kh-form-msg" role="status" aria-live="polite" hidden style={{ margin: "0", padding: "12px 16px", borderRadius: "14px", fontWeight: "700" }} />
        <button type="submit" style={{ minHeight: "56px", borderRadius: "18px", border: "0", background: "#46D3BE", color: "#0B1240", fontWeight: "800", fontSize: "18px", cursor: "pointer", boxShadow: "0 5px 0 #1E8F80" }}>
          {t.contact.sendMyRequest}
        </button>
        <span style={{ fontSize: "13px", color: "#4B5480" }}>
          {t.contact.fieldsMarkedWith}
          <span className="kh-req">
            *
          </span>
          {t.contact.areRequiredYourData}
          <a href="/privacy" target="_blank" rel="noopener">
            {t.contact.privacyPolicy}
          </a>
        </span>
      </form>
    </section>
  );
};

export default Contact;
